module.exports = __webpack_public_path__ + "static/logo-cf0fc7ee5a1807e339462f8a4891b542.png";